module.exports = __webpack_public_path__ + "static/media/icon-vehicle.bd51940b.svg";